//#region src/redux/view-port/thunk-types.ts
var thunkTypes = { UPDATE_VIEW_PORT: `viewport/updateViewPort` };
//#endregion
export { thunkTypes };

//# sourceMappingURL=thunk-types.js.map